import Const from '@/core/const';

/** 订单状态 */
export const ORDER_STATUS = Const.OCCUPY.STATUS;

/** 订单状态 */
export const ORDER_STATUS_MARK = Const.OCCUPY.STATUS_MARK;

/** 欠款订单订单状态 */
export const PURSUE_STATUS = Const.PURSUE.STATUS;

/** 汽车充占位费  计费模式 */
export const CAR_OCCUPY_MODE = Const.CHARGE.CAR_OCCUPY.MODE;

/** 金额变动类型 */
export const MONEY_TYPE = Const.MONEY_CHARGE_TYPE;

/** 订单退款状态 */
export const REFUND_STATUS = Const.ORDER.REFUND_STATUS;
export const REFUND_MARK = Const.ORDER.REFUND_STATUS_MARK;

/** 科目 */
export const SUBJECT = {
	PRE_OCCUPY: 100, // 占位费（充电后）
	// MARKETING: 200, // 充电预付-红包
	// INSURANCE: 300, // 安心充电-次卡

	// CHARGING_AFTER: 400,  // 充电费 二次退款
	// OCCUPY_AFTER: 401,  // 预约占位 二次退款
	// MARKETING_AFTER: 500, // 二次退款

	// INSURANCE_ERROR: 600, // 保单多退
}
export const SUBJECT_MAP = {
	'100': { text: '占位费（充电后）' },
}

/** 金额变动类型 */
export const MONEY_CHARGE_TYPE = Const.MONEY_CHARGE_TYPE;

/** 方法 */
export const PAY_METHOD = Const.OCCUPY.PAY_METHOD;
export const PAY_METHOD_MAP = Const.OCCUPY.PAY_METHOD_MAP;
export const PAY_METHOD_MARK = Const.OCCUPY.PAY_METHOD_MARK;

/** 状态 */
export const STATUS = {
	DOING: 0,
	SUCCESS: 1,
	FAILURE: 2,
}
export const STATUS_MAP = {
	'0': { color: 'orange', text: '中' },
	'1': { color: 'green', text: '成功' },
	'2': { color: 'red', text: '失败' },
}

/** 状态 */
export const CUSTOM_TYPE = {
	receivable: 1,
	refund: 2,
	debt: 3,
}
export const CUSTOM_TYPEE_MAP = {
	'1': { color: 'green', text: '已收' },
	'2': { color: 'red', text: '退款' },
	'3': { color: 'red', text: '欠款' },
}

/** 订单类型 */
export const CUSTOM_ORDER_TYPE = {
	occupy: 'occupy',
	pursue: 'pursue',
}